import * as z from 'zod';
import { wipProjectId } from '../../types/opaque.mjs';
import { hasWipProjectIdentity } from '../../utils/normalize-wip-project-identifiers.util.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: wipProjectId,
            name: z.string().nullable(),
            projectNumber: z.string().nullable(),
            displayName: z.string(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
const adminProjectIdentifiersSchema = z.object({
    name: z.string().nullish(),
    projectNumber: z.string().nullish(),
});
var Create;
(function (Create) {
    (function (Admin) {
        (function (Request) {
            Request.schema = adminProjectIdentifiersSchema.refine((data) => hasWipProjectIdentity({ name: data.name, number: data.projectNumber }), {
                message: "A project must have a name or a project number",
                path: ["name"],
            });
        })(Admin.Request || (Admin.Request = {}));
    })(Create.Admin || (Create.Admin = {}));
})(Create || (Create = {}));
var Update;
(function (Update) {
    (function (Admin) {
        (function (Request) {
            Request.schema = adminProjectIdentifiersSchema.refine((data) => data.name !== undefined || data.projectNumber !== undefined, {
                message: "At least one field is required",
            });
        })(Admin.Request || (Admin.Request = {}));
    })(Update.Admin || (Update.Admin = {}));
})(Update || (Update = {}));

export { Create, Get, Update };
